import * as React from 'react';

import Box, { Props as BoxProps } from 'components/Box';
import BoxBody from 'components/BoxBody';

type Props = {
  children: React.ReactNode;
} & BoxProps;

export default function AdminUpgradeSidebar({ children, ...others }: Props) {
  return (
    <Box {...others} className="AdminUpgradeSidebar">
      <BoxBody size="small">{children}</BoxBody>
    </Box>
  );
}
